import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Row, Col } from 'reactstrap';

const regexEmail =
  // eslint-disable-next-line max-len
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const regexCardNumber = /^\d{8}$/;

const emailValid = (email) => regexEmail.test(email);
const cardNumberValid = (cardNumber) => regexCardNumber.test(cardNumber);

const SalesInput = ({ data, onChange }) => {
  const { t } = useTranslation();

  const [inputData, setInputData] = useState({ email: data.email || '', cardNumber: '' });
  const [errors, setErrors] = useState({ email: false, cardNumber: false });

  const onInputChange = ({ target }) => {
    const { name, value } = target;
    const isValid = name === 'email' ? emailValid(value) : cardNumberValid(value);

    setInputData({
      ...inputData,
      [name]: value
    });
    setErrors({
      ...errors,
      [name]: !isValid
    });

    if (isValid) {
      const productId = data.subProductId || data.productId;
      onChange({ name, value }, productId, data.id);
    }
  };

  return (
    <Row className="mb-1">
      <Col>
        <Input
          type="text"
          name="email"
          placeholder={t('default.enter-email', 'Ange e-post')}
          value={inputData.email}
          invalid={errors.email}
          onChange={onInputChange}
          className="px-3 mb-0"
          // autoComplete="off"
        />
      </Col>
      <Col>
        {!data.digital ? (
          <Input
            type="text"
            name="cardNumber"
            placeholder={t('default.enter-card-nr', 'Ange kortnummer')}
            value={inputData.cardNumber}
            invalid={errors.cardNumber}
            onChange={onInputChange}
            className="px-3 mb-0"
            autoComplete="off"
          />
        ) : (
          <Input
            disabled
            value={t('sales.digital-card-send', 'Digitalt kortnummer skickas till uppgiven e-post')}
          />
        )}
      </Col>
    </Row>
  );
};

export default SalesInput;
